import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './axios'
import { setupMirage } from './mirage'
import { setupSentry } from './sentry'

import InlineSvg from 'vue-inline-svg'
import QRCode from '@chenfengyuan/vue-qrcode'

if (process.env.NODE_ENV === 'development') {
  if (JSON.parse(process.env.VUE_APP_MIRAGE_ENABLED)) {
    setupMirage()
  }
}

const app = createApp(App)

setupSentry(app, router)

app.use(router)
app.use(store)
app.provide('axios', axios)
app.component('InlineSvg', InlineSvg)
app.component('QRCode', QRCode)
app.mount('#app')
